/** Live-Meeting klingt nach Vor-Ort — öffentlich immer als Online kenntlich. */
export function clarifyOnlineWording(text?: string | null): string {
  let out = String(text || '').trim();
  if (!out) return '';

  out = out.replace(/Online-Live-Meetings?/gi, '§OLM§');
  out = out.replace(/Online Live-Meetings?/gi, '§OLM§');
  out = out.replace(/Online-Seminare?/gi, '§OS§');
  out = out.replace(/Online-Livestreams?/gi, '§OLS§');
  out = out.replace(/Online Live-Streams?/gi, '§OLS§');

  out = out.replace(/Live-Meetings?/gi, 'Online-Live-Meeting');
  out = out.replace(/Live-Seminare?/gi, 'Online-Seminar');
  out = out.replace(/Live-Streams?/gi, 'Online-Livestream');
  out = out.replace(/\bLivestreams?\b/gi, 'Online-Livestream');

  out = out.replace(/§OLM§/g, 'Online-Live-Meeting');
  out = out.replace(/§OS§/g, 'Online-Seminar');
  out = out.replace(/§OLS§/g, 'Online-Livestream');
  return out;
}

export function clarifyOnlineFormat(format?: string | null): string {
  const clarified = clarifyOnlineWording(format);
  if (!clarified) return 'Online-Livestream';
  if (/^online\b/i.test(clarified)) return clarified;
  return `Online · ${clarified}`;
}

/** Nur für Externe auf der öffentlichen Landing/Mail — Intern bekommen die Aufzeichnung über PE One. */
export const RECORDING_LIVE_ONLY_COPY =
  'Du kannst nur am Live-Meeting teilnehmen. Die Aufzeichnung wird dir im Anschluss nicht zur Verfügung gestellt.';

